'use client'

import { useAtom } from 'jotai'

import Icon from '@/components/ui/icon'
import { trackStateAtom } from '@/components/nav/primary/state'

export default function NavMobileToggle() {
  const [trackVisible, setTrackVisible] = useAtom(trackStateAtom)

  return (
    <button onClick={() => setTrackVisible(!trackVisible)} className="l-up:hidden">
      {!trackVisible ? (
        <>
          <Icon id="icon-mobile-menu" className="h-[24px] w-[24px]" />
          <span className="sr-only">Open the mobile menu</span>
        </>
      ) : (
        <>
          <Icon id="icon-panel-close" className="h-[19px] w-[19px]" />
          <span className="sr-only">Close the mobile menu</span>
        </>
      )}
    </button>
  )
}
